import * as React from 'react';
import { antGrey, runwayColors, titleStyle } from '@/components/styles/globalStyles';
import Tag from 'antd/lib/tag';
import { WorkflowRunOverviewDisplayStatus } from '@/types/workflowOverview';
import {
    displayTextForWorkflowRunOverviewDisplayStatus,
    colorForWorkflowRunOverviewDisplayStatus,
} from '@/helpers/displayHelpers';
import { EllipsisOutlined } from '@ant-design/icons';

interface RunStatusTagProps {
    overviewDisplayStatus: WorkflowRunOverviewDisplayStatus;
    shouldRenderEllipsis: boolean;
}

export const RunStatusTag: React.FC<RunStatusTagProps> = ({ overviewDisplayStatus, shouldRenderEllipsis }) => {
    const overviewDisplayStatusText = displayTextForWorkflowRunOverviewDisplayStatus(overviewDisplayStatus);
    if (!overviewDisplayStatusText) {
        return null;
    }

    const isSkippedStatus = overviewDisplayStatus === WorkflowRunOverviewDisplayStatus.Skipped;

    const tagBGColor = colorForWorkflowRunOverviewDisplayStatus(overviewDisplayStatus);
    const shouldLightenTagContent = isSkippedStatus;

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'stretch',
                gap: 12,
            }}
        >
            <Tag
                style={{
                    ...titleStyle,
                    fontSize: 10,
                    lineHeight: '22px',
                    margin: 0,
                    color: runwayColors.white,
                    opacity: shouldLightenTagContent ? '60%' : '100%',
                }}
                color={tagBGColor}
            >
                <div
                    style={{
                        height: '100%',
                        width: '100%',
                        textAlign: 'center',
                        position: 'relative',
                        top: 0,
                        display: 'flex',
                        justifyContent: 'space-between',
                        justifyItems: 'center',
                        alignItems: 'stretch',
                        gap: 8,
                    }}
                >
                    {overviewDisplayStatusText}
                    {shouldRenderEllipsis && (
                        <EllipsisOutlined
                            color={runwayColors.white}
                            style={{
                                fontSize: '16px',
                            }}
                        />
                    )}
                </div>
            </Tag>
        </div>
    );
};

interface HotfixStatusTagProps {
    shouldLightenTagContent: boolean;
}

export const HotfixStatusTag: React.FC<HotfixStatusTagProps> = ({ shouldLightenTagContent }) => {
    return (
        <Tag
            style={{
                ...titleStyle,
                fontSize: 10,
                lineHeight: '22px',
                margin: 0,
                color: runwayColors.white,
                opacity: shouldLightenTagContent ? '60%' : '100%',
            }}
            color={antGrey.grey8}
        >
            Hotfix
        </Tag>
    );
};

interface ReleaseTypeTagProps {
    releaseTypeText: string;
    shouldLightenTagContent?: boolean;
    style?: React.CSSProperties;
}

export const ReleaseTypeTag: React.FC<ReleaseTypeTagProps> = ({
    releaseTypeText,
    shouldLightenTagContent = false,
    style,
}) => {
    if (!releaseTypeText) return null;

    return (
        <Tag
            style={{
                ...titleStyle,
                fontSize: 10,
                lineHeight: '22px',
                margin: 0,
                color: runwayColors.white,
                opacity: shouldLightenTagContent ? '60%' : '100%',
                ...style,
            }}
            color={antGrey.grey7}
        >
            {releaseTypeText}
        </Tag>
    );
};
